module.exports = __webpack_public_path__ + "./images/icomoon.d00c24.svg";